<sl-textarea 
    ngDefaultControl
    [name]="key"
    [label]="props.label | htmlDecode"
    [shoelaceReadonly]="props.readonly"
    [disabled]="props.disabled || false" 
    [required]="props.required || false" 
    [placeholder]="props.placeholder"
    [formControl]="formControl" 
    [formlyAttributes]="field"
    [value]="props['defaultValue']">
</sl-textarea>